<script lang="ts">
	//UI
	import ComponentCover from "../common/ComponentCover.svelte";
	import EditBuisnessHourRow from "./EditBuisnessHourRow.svelte";
	import ComponentLoading from "../common/ComponentLoading.svelte";
	import { Card } from "@hitit/new_ui";
	//Image
	import EditIcon from "@hitit/hub/src/assets/Icons/Edit.png";
	import SaveIcon from "@hitit/hub/src/assets/Icons/Save.png";
	//Utils
	import type { PlaceDTO } from "@hitit/api";
	import type { MixinPlacedata } from "../../../functions/place/types";
	import {
		PlaceGetConverter,
		PlacePostConverter,
	} from "../../../functions/place/hellper";
	import { api, t } from "@hitit/hub/src/stores";

	export let storeId = "";
	export let editmode = false;
	export let coverStatus = false;
	export let editable = true;
	export let placeDTO: PlaceDTO;

	let loading = false;

	$: {
		setDisplayValue(placeDTO);
	}

	const midnight = "23:59";
	const timeArrange = (start: string, end: string) => {
		let close = end === midnight ? "24:00" : end;
		let nextDay =
			Number(start.replace(":", "")) > Number(end.replace(":", ""))
				? "다음날 "
				: "";
		return start + " - " + nextDay + close;
	};

	let displayValue = convertPlaceDTO(placeDTO);
	let openHours: typeof displayValue.openHours = [];

	function setDisplayValue(place: PlaceDTO) {
		displayValue = convertPlaceDTO(place);
		openHours = displayValue.openHours;
	}

	function convertPlaceDTO(placeDTO: PlaceDTO) {
		const mixinData = Object.assign({}, placeDTO, {
			categories: [],
		}) as MixinPlacedata;

		return PlaceGetConverter.convertChangeableDisplayValues(mixinData);
	}

	async function actionHandler() {
		if (!editmode) {
			editmode = true;
			return;
		}

		try {
			loading = true;
			const mixinData = Object.assign({}, placeDTO, {
				categories: [],
			}) as MixinPlacedata;

			const postPlaceDTO = PlacePostConverter.convertPlaceDataToPostParam(
				mixinData,
				displayValue
			);
			delete postPlaceDTO.categories;

			await $api.postPlaceInfomation(storeId, postPlaceDTO);
			placeDTO = postPlaceDTO as PlaceDTO;
			editmode = false;
		} catch (e) {
			console.log(e);
		} finally {
			loading = false;
		}
	}
</script>

<Card noPadding>
	<div class="container" class:editmode={editmode} t-id="buisnesshour">
		{#if editable}
			<div class="action" on:click={actionHandler}>
				<span>{editmode ? $t("global.done") : $t("global.edit")}</span>
				<img
					src={editmode ? SaveIcon : EditIcon}
					alt={editmode ? "save" : "edit"}
				/>
			</div>
		{/if}
		{#if loading}
			<ComponentLoading />
		{/if}
		{#if coverStatus}
			<ComponentCover />
		{/if}
		{#if editmode}
			<div class="buisenesshour" id="monday-friday">
				{#each openHours.slice(0, 7) as openHour}
					<EditBuisnessHourRow
						day={$t(`hub.place.${openHour.day}`)}
						bind:dayoff={openHour.dayOff}
						bind:open={openHour.open}
						bind:close={openHour.close}
					/>
				{/each}
			</div>
		{:else}
			<div class="buisenesshour">
				{#each openHours.slice(0, 7) as openHour}
					<div class="openhour-static-row" class:dayOff={openHour.dayOff}>
						<span class="day">{$t(`hub.place.${openHour.day}`)}</span>
						<span>
							{openHour.dayOff
								? $t("hub.place.Off")
								: timeArrange(openHour.open, openHour.close)}
						</span>
					</div>
				{/each}
			</div>
		{/if}
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		width: 100%;
		position: relative;
		display: flex;
		flex-direction: column;
		padding: 20px 10px;
		gap: 20px;

		&.editmode {
			padding: 43px 10px 20px 10px;
			gap: 14px;
			.buisenesshour {
				gap: 14px;
			}
		}

		.action {
			display: flex;
			gap: 10px;
			align-items: center;
			position: absolute;
			right: 10px;
			top: 10px;
			color: #6d6f76;
			font-weight: 500;

			&:hover {
				cursor: pointer;
			}
			img {
				width: 24px;
				height: 24px;
				object-fit: contain;
			}
		}
		.buisenesshour {
			display: flex;
			flex-direction: column;
			gap: 20px;

			:global(span.day) {
				font-weight: 500;
			}

			.openhour-static-row {
				display: flex;
				gap: 20px;
				font-size: 1.25rem;
				color: #46474b;
				@include appleAdjustTextForSize(16);
			}
			.dayOff {
				color: #e54848;
			}
		}
		.status {
			width: 60px;
			height: 60.2px;
			position: absolute;
			bottom: 21px;
			right: 11px;
		}
	}

	@include DesktopSize {
		.container {
			flex-direction: row;
			padding: 30px;
			gap: 0px;
			.action {
				top: 20px;
				right: 20px;
				font-size: 1.25rem;
			}
			.buisenesshour {
				width: 320px;
				gap: 30px;
				.openhour-static-row {
					@include appleAdjustTextForSize(16, false);
				}
			}
			.status {
				right: 20px;
				width: 80px;
				height: 80.5px;
			}

			&.editmode {
				padding: 30px;

				#start-friday {
					justify-content: flex-end;
				}
				.buisenesshour {
					width: auto;
					gap: 29px;
				}
			}
		}
	}
</style>
